module.exports = __webpack_public_path__ + "img/11.b57ec8f5.jpg";